import * as React from 'react';

import { Divider } from '@/components/ui';

interface StepCardProps {
  step: number;
  heading: string;
  copy: string;
}

export const StepCard = React.memo<StepCardProps>(({ step, heading, copy }) => {
  return (
    <div className='mx-auto text-center md:text-left pt-4'>
      <div className='md:w-auto mx-auto md:mx-0 text-center'>
        <span className='text-[114px] font-bodoni font-normal bg-clip-text text-transparent bg-gradient-yellow-to-purple leading-[114px]'>
          {step}
        </span>
      </div>
      <header className='flex flex-col'>
        <h4
          className='mx-auto text-center text-2xl font-lato font-bold mb-2 md:mb-0 my-2 md:-order-1'
          dangerouslySetInnerHTML={{ __html: heading }}
        />
        <Divider className='text-khaki-3 my-4 md:my-6' variant='stubby' />
      </header>
      <div className='text-sm text-center'>{copy}</div>
    </div>
  );
});

StepCard.displayName = 'StepCard';
